import BaseRestService from "../../Service/BaseRestService";

class IconsService extends BaseRestService {
  async fetchIcons(provider) {
    const url = `https://${window.location.hostname}/ac/icons/${provider}`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }
}

export const iconsService = new IconsService();
